import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { useAuth } from 'contexts/AuthContext';

export default function Footer() {
  const { user } = useAuth();
  if (!user || String(user.role || '').trim().toLowerCase() !== 'admin') {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        right: 16,
        bottom: 16,
        color: 'text.secondary'
      }}
    >
      <Typography variant="caption" sx={{ fontWeight: 600 }}>
        CRM VRP 3.3
      </Typography>
    </Box>
  );
}
